import React from 'react';
import { useTranslation } from 'react-i18next';
import { QButton } from '@qualio/ui-components';
import { Form } from '../../../../types';

type HeaderSendForApprovalButtonProps = {
  data: Form;
  shouldShowActionButton: boolean;
  callback: () => void;
  isDisabled?: boolean;
  isApiLoading?: boolean;
};

export const HeaderSendForApprovalButton: React.FC<HeaderSendForApprovalButtonProps> = ({
  data,
  shouldShowActionButton = false,
  callback,
  isDisabled = false,
  isApiLoading = false,
}) => {
  const { t } = useTranslation();
  const shouldShowSendForApprovalButton = ['draft', 'for_review'].includes(data.status) && shouldShowActionButton;

  return shouldShowSendForApprovalButton ? (
    <QButton
      aria-label="send-for-approval"
      data-cy="send-for-approval"
      isLoading={isApiLoading}
      isDisabled={isDisabled}
      onClick={callback}
    >
      {t('forms.actions.sendForApproval')}
    </QButton>
  ) : null;
};
